module.exports = __webpack_public_path__ + "static/media/location.ba104803.svg";